module.exports = __webpack_public_path__ + "static/img/6.22c0d31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/6.png
// module id = NIea
// module chunks = 0